const ComparasiEnty = {
    idKelas:null,
    idKelasParalel:null,
    idPaketProgram:null,
    kodeCbt: null
};

export default ComparasiEnty;